import type {
  GroupResponsibleState,
  ParticipantFilterType,
} from '@/scopes/account/group-responsible/domain/types'
import { sortParticipants } from './utils'

export function getParticipantExtraInfo(state: GroupResponsibleState) {
  const activeParticipant = state.activeExtraInfoId ? state.participants[state.activeExtraInfoId] : null
  let roomData

  if (state.rooms) {
    roomData = Object.values(state.rooms).find((room) => {
      return room.participantsId.includes(Number(activeParticipant?.id))
    })
  }

  return {
    name: activeParticipant?.name || '',
    bookingNumber: activeParticipant?.bookingNumber,
    email: activeParticipant?.email || '-',
    room: activeParticipant?.room || '-',
    mobileNumber: activeParticipant?.mobileNumber,
    telephoneNumber: activeParticipant?.telephoneNumber,
    skiPass: activeParticipant?.skiPass || '-',
    hasSkiMaterial: activeParticipant?.hasSkiMaterial ? 'groups_responsible_yes' : 'groups_responsible_no',
    hasTotallySweater: activeParticipant?.hasTotallySweater ? 'groups_responsible_yes' : 'groups_responsible_no',
    accommodationName: roomData?.accommodationName || '-',
    roomType: roomData?.type || '-',
  }
}

export function getParticipantCounts(state: GroupResponsibleState): {
  all: number
  notPaid: number
  partialPaid: number
  paid: number
} {
  const participants = Object.values(state.participants)

  const all = participants.length
  const notPaid = participants.filter(p => p.status.text === 'groups_responsible_not_paid').length
  const partialPaid = participants.filter(p => p.status.text === 'groups_responsible_partial_paid').length
  const paid = participants.filter(p => p.status.text === 'groups_responsible_paid').length

  return { all, notPaid, partialPaid, paid }
}

export function getFilteredParticipants(state: GroupResponsibleState, filter: ParticipantFilterType, searchTerm = '') {
  const trimmedSearchTerm = searchTerm.trim().toLowerCase()
  return Object.values(state.participants)
    .filter((participant) => {
      const matchesStatus = filter === 'all' || participant.status.text === `groups_responsible_${filter}`
      const matchesSearch = trimmedSearchTerm === '' || participant.name.toLowerCase().includes(trimmedSearchTerm)
      return matchesStatus && matchesSearch
    })
    .sort(sortParticipants)
}
